import * as actions from './form.actions';
import { EntityState, createEntityAdapter, Update } from '@ngrx/entity';
import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { FormBaseModel } from '@smarttask-common/src/lib/models/Form/Core/FormBaseModel';

export const formAdapter = createEntityAdapter<FormBaseModel>({
    selectId: (x) => x.form_id,
});
export interface FormState extends EntityState<FormBaseModel> {
    selected_form_id: string;
}

export const initialState: FormState = formAdapter.getInitialState({
    selected_form_id: undefined,
});

export function FormReducers(state: FormState = initialState, action: actions.FormActions) {
    switch (action.type) {
        case actions.FormActionTypes.UPDATE_SELECTED_ID:
            state = { ...state, selected_form_id: action.selected_form_id };
            //console.log(state);
            return state;

        case actions.FormActionTypes.ADD_FORM:
            return formAdapter.addOne(action.form, state);

        case actions.FormActionTypes.ADD_FORMS:
            return formAdapter.addMany(action.forms, state);

        case actions.FormActionTypes.UPSERT_FORM:
            return formAdapter.upsertOne(action.form, state);

        case actions.FormActionTypes.UPSERT_FORMS:
            return formAdapter.upsertMany(action.forms, state);

        case actions.FormActionTypes.UPDATE_FORM:
            return formAdapter.updateOne(action.form, state);

        case actions.FormActionTypes.UPDATE_FORMS:
            return formAdapter.updateMany(action.forms, state);

        case actions.FormActionTypes.DELETE_FORM:
            // if(state.selectedFormId == action.id){
            //   state.selectedFormId = undefined;
            // }
            return formAdapter.removeOne(action.id, state);

        case actions.FormActionTypes.DELETE_FORMS:
            // if(action.ids.indexOf(state.selectedFormId) > -1){
            //   state.selectedFormId = undefined;
            // }
            return formAdapter.removeMany(action.ids, state);

        case actions.FormActionTypes.DELETE_ALL_FORMS:
            return formAdapter.removeMany(action.ids, state);

        case actions.FormActionTypes.DELETE_ALL:
            return formAdapter.removeAll(state);

        default:
            return state;
    }
}

export const getFormState = createFeatureSelector<FormState>('form');

export const { selectIds, selectEntities, selectAll, selectTotal } = formAdapter.getSelectors(getFormState);

const getSelectedFormIdState = (state: FormState) => {
    return state.selected_form_id;
};
export const getSelectedFormId = createSelector(getFormState, getSelectedFormIdState);

export const getSelectedForm = createSelector(getFormState, (state: FormState) => {
    if (state.selected_form_id == undefined) {
        return undefined;
    }
    return state.entities[state.selected_form_id];
});